import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import OrderDetailModal from './OrderDetail/OrderDetailModal';
import OrderManagementFilter from './components/OrderManagementFilter';
import OrderManagementTable from './components/OrderManagementTable';
import { PageTitle } from '../../../components/Common/PageTitle';
import {
  EnumOrderGroupStatus,
  EnumOrderListFilter,
  EnumPage,
} from '../../../constants/enum';
import {
  openSelectCurrentRestaurantModal,
  setRingBell,
} from '../../Setting/actions';
import {
  changeTableActivePage,
  changeTablePageSize,
  closeDialogGeneric,
} from '../../../redux/genericAction';
import {
  getListInfo,
  getListManagerOrder,
  getOrderDetail,
  handleChangeFilters,
} from './actions';
import { getDate, isEmptyObject } from '../../../utils/utils';
import { trans } from '../../../localization';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';

import './Order.scss';
import { ORDER_AUTO_RELOAD_INTERVAL } from '../../../constants/constants';

class OrderManagement extends React.Component {
  reloadInterval = null;

  componentDidMount() {
    const { currentRestaurant, handleChangeFiltersConnect } = this.props;
    handleChangeFiltersConnect('status', {
      value: EnumOrderGroupStatus.PROCESSING.id,
      label: trans(EnumOrderGroupStatus.PROCESSING.description),
    });
    handleChangeFiltersConnect('filter', {
      value: EnumOrderListFilter.ALL.id,
      label: trans(EnumOrderListFilter.ALL.description),
    });
    if (!isEmptyObject(currentRestaurant)) {
      this.searchOrder();
    }
  }

  componentDidUpdate(prevProps) { 
    const { currentRestaurant, getListManagerOrderConnect } = this.props;
    if (prevProps.currentRestaurant.restaurant_id !== currentRestaurant.restaurant_id) {
      getListManagerOrderConnect()
    }
  }

  componentWillUnmount() {
    clearInterval(this.reloadInterval);
  }

  searchOrder = () => {
    clearInterval(this.reloadInterval);
    const { getListManagerOrderConnect, filters } = this.props;
    const { status } = filters;
    if (
      filters.isAutoReload &&
      status.value === EnumOrderGroupStatus.PROCESSING.id
    ) {
      this.reloadInterval = setInterval(
        () => getListManagerOrderConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }
    getListManagerOrderConnect(true);
  };

  handleSearchToday = () => {
    const { handleChangeFiltersConnect } = this.props;
    handleChangeFiltersConnect('fromDate', getDate());
    handleChangeFiltersConnect('toDate', getDate());
    this.searchOrder();
  };

  changeFilterStatus = value => {
    const { filters, handleChangeFiltersConnect } = this.props;
    const { status, filter, isAutoReload } = filters;

    if (value === null || value.value !== status.value) {
      handleChangeFiltersConnect('status', value);

      if (
        value.value !== EnumOrderGroupStatus.COMPLETED.id &&
        filter.value !== EnumOrderListFilter.ALL.id
      ) {
        handleChangeFiltersConnect('filter', {
          value: EnumOrderListFilter.ALL.id,
          label: trans(EnumOrderListFilter.ALL.description),
        });
      }
    }

    if (value.value === EnumOrderGroupStatus.SCHEDULED.id) {
      handleChangeFiltersConnect('fromDate', getDate());
      handleChangeFiltersConnect('toDate', getDate(3));
    } else if (status.value === EnumOrderGroupStatus.SCHEDULED.id) {
      handleChangeFiltersConnect('fromDate', getDate());
      handleChangeFiltersConnect('toDate', getDate());
    }

    clearInterval(this.reloadInterval);

    const { getListManagerOrderConnect } = this.props;
    const isSetNewInterval =
      value &&
      value.value === EnumOrderGroupStatus.PROCESSING.id &&
      isAutoReload;

    if (isSetNewInterval) {
      this.reloadInterval = setInterval(
        () => getListManagerOrderConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }

    getListManagerOrderConnect(true);
  };

  toggleAutoReload = () => {
    const { filters, getListManagerOrderConnect } = this.props;
    if (filters.isAutoReload) {
      clearInterval(this.reloadInterval);
    } else {
      this.reloadInterval = setInterval(
        () => getListManagerOrderConnect(false),
        ORDER_AUTO_RELOAD_INTERVAL,
      );
    }
    this.props.handleChangeFiltersConnect(
      'isAutoReload',
      !filters.isAutoReload,
    );
  };

  render() {
    const {
      filters,
      restaurants,
      openSelectCurrentRestaurantModalConnect,
      currentRestaurant,
      changeTableActivePageConnect,
      getListInfoConnect,
      table,
      getOrderDetailConnect,
      dialog,
      closeDialogGenericConnect,
      changeTablePageSizeConnect,
      setGeneralErrorConnect,
    } = this.props;
    const { itemDetail, isOpenDialog } = dialog;
    return (
      <React.Fragment>
        <PageTitle title={trans('mod_manager')} />
        <OrderManagementFilter
          filters={filters}
          restaurants={restaurants}
          currentRestaurant={currentRestaurant}
          openSelectCurrentRestaurantModal={
            openSelectCurrentRestaurantModalConnect
          }
          handleSearchOrder={this.searchOrder}
          handleSearchToday={this.handleSearchToday}
          toggleAutoReload={this.toggleAutoReload}
          changeFilterStatus={this.changeFilterStatus}
        />
        <OrderManagementTable
          table={table}
          filters={filters}
          changeActivePage={changeTableActivePageConnect}
          changePageSize={changeTablePageSizeConnect}
          getList={getListInfoConnect}
          getOrderDetail={getOrderDetailConnect}
          handleSearchOrder={this.searchOrder}
        />
        <OrderDetailModal
          itemDetail={itemDetail}
          isOpenDialog={isOpenDialog && !isEmptyObject(itemDetail)}
          closeDialogGeneric={closeDialogGenericConnect}
          setGeneralError={setGeneralErrorConnect}
          dialog={dialog}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  table: state.order.table,
  filters: state.order.filters,
  dialog: state.order.dialog,
});

const mapDispatchToProps = dispatch => {
  const PAGE = EnumPage.ORDER_MANAGEMENT.id;
  return {
    openSelectCurrentRestaurantModalConnect: isShow => {
      dispatch(openSelectCurrentRestaurantModal(isShow));
    },
    closeDialogGenericConnect: () => {
      dispatch(closeDialogGeneric(PAGE));
    },
    handleChangeFiltersConnect: (name, value) => {
      dispatch(handleChangeFilters(name, value));
    },
    changeTableActivePageConnect: activePage => {
      dispatch(changeTableActivePage(PAGE, activePage));
    },
    changeTablePageSizeConnect: pageSize => {
      dispatch(changeTablePageSize(PAGE, pageSize));
    },
    setGeneralErrorConnect: message => {
      dispatch(setGeneralError(message));
    },
    getListManagerOrderConnect: (isLoading = true) =>
      dispatch(getListManagerOrder(isLoading)),
    getListInfoConnect: ids => dispatch(getListInfo(ids)),
    getOrderDetailConnect: orderCode => {
      dispatch(getOrderDetail(orderCode));
      dispatch(setRingBell(false));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OrderManagement),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderManagement.jsx